import { ErrorMessage, Field, FieldArray, Form, FormikProvider, useFormik } from 'formik'
import { useEffect, useState } from 'react'
import CommonFormHeading from '../../CommonUtils/CommonFormHeading'
import * as bie from "react-bootstrap";
import { FaEye, FaRegTrashAlt } from 'react-icons/fa';
import { VscDiffAdded } from 'react-icons/vsc';
import { viewImage } from '../../CommonUtils/viewImage';
import Swal from 'sweetalert2';
import { CommonAxiosGet, CommonAxiosPost } from '../../CommonUtils/CommonAxios';
import { failureAlert, successAlert2, successAlertRefresh } from '../../CommonUtils/SweetAlerts';
import { config } from '../../CommonUtils/CommonURLS';
import { allowAlphabetAndSpacesOnly } from '../../CommonUtils/CommonValidations';
import { ImagePdfBucket } from '../../CommonUtils/ImagesBase64';
import { BiTrash } from 'react-icons/bi';
export default function AffiliationInspUploads() {
    const userId = sessionStorage.getItem('user_id');
    const acYear = sessionStorage.getItem('ac_year');

    const AfflInspUploadsFormik = useFormik({
        enableReinitialize: true,
        initialValues: {
            AfflInspUploadArray: [{
                docDescription: "",
                docUploadingDate: "",
                docUploading: "",
                docUploadinghidden: "",
            }],
        },

        onSubmit: (values) => {
            const missingFields = []; // To store missing fields

            // Identify rows with missing fields
            values?.AfflInspUploadArray.forEach((item, index) => {
                let rowErrors = [];

                if (!item.docDescription) {
                    rowErrors.push('Document Description');
                }
                if (!item.docUploadingDate) {
                    rowErrors.push('Document Date');
                }
                if (!item.docUploading) {
                    rowErrors.push('Upload Document');
                }


                // Only add row errors if any field is missing
                if (rowErrors.length > 0) {
                    missingFields.push({ index, errors: rowErrors });
                }
            });

            if (missingFields.length > 0) {
                // Start the validation process row by row
                const validateNextRow = (currentIndex) => {
                    if (currentIndex >= missingFields.length) {
                        Swal.fire({
                            text: 'Are you sure you want to submit?',
                            icon: 'warning',
                            showCancelButton: true,
                            confirmButtonText: 'Yes, submit it!',
                            cancelButtonText: 'No, cancel!',
                            backdrop: false,
                        }).then((result) => {
                            if (result.isConfirmed) {
                            }
                        });
                        return;
                    }

                    const row = missingFields[currentIndex];
                    const { index, errors } = row;
                    Swal.fire({
                        title: "Required",
                        text: ` At Row ${index + 1}:   ${errors.join(', ')}.`,
                        icon: 'error',
                        backdrop: false,

                    });
                };
                validateNextRow(0);
            } else {
                Swal.fire({
                    text: 'Are you sure you want to submit?',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Yes, submit it!',
                    cancelButtonText: 'No, cancel!',
                }).then((result) => {
                    if (result.isConfirmed) {
                        const url = `${config.url.API_URL}saveOamdcFfcaUploads`;
                        CommonAxiosPost(url, values?.AfflInspUploadArray).then((res) => {
                            if (res?.data?.scode === '01') {
                                successAlert2(res?.data?.sdesc);
                                GetFFcaInspUploadsData();
                            } else {
                                failureAlert(res?.data?.sdesc);
                            }
                        });
                    }
                });
            }
        }

    })


    const [FfcaUploads, setFfcaUploads] = useState([]);
    function GetFFcaInspUploadsData() {
        let url = config.url.API_URL + `getOamdcFfcaUploads`;
        CommonAxiosGet(url).then((res) => {
            if (res?.data?.scode === '01') {
                setFfcaUploads(res?.data?.getOamdcFfcaUploads);
                res?.data?.getOamdcFfcaUploads?.forEach((course, i) => {
                    AfflInspUploadsFormik?.setFieldValue(`AfflInspUploadArray[${i}].docDescription`, course?.doc_descrption);
                    AfflInspUploadsFormik?.setFieldValue(`AfflInspUploadArray[${i}].docUploadingDate`, course?.doc_uploading_date);
                    AfflInspUploadsFormik?.setFieldValue(`AfflInspUploadArray[${i}].docUploading`, course?.doc_uploading);
                })

            }
            else {
                setFfcaUploads([]);
            }
        })
    }

    useEffect(() => {
        GetFFcaInspUploadsData();
    }, [])


    const DeleteUploadFile = (sno) => {
        const deleteffcaPayload = {
            slno: sno,
        };
        Swal.fire({
            title: `Are you sure want to Delete the File?`,
            showDenyButton: false,
            showCancelButton: true,
            confirmButtonText: "Delete",
            cancelButtonText: "Not Delete",
        }).then((result) => {
            if (result.isConfirmed) {
                CommonAxiosPost(config.url.API_URL + "deleteUploadsslno", deleteffcaPayload).then((res) => {
                    if (res.data.scode === "01") {
                        successAlertRefresh(res.data.sdesc);
                    } else {
                        failureAlert(res.data.sdesc);
                    }
                });
            }
        });

    };


    return (
        <>
            <CommonFormHeading heading="Document Uploads " />
            <bie.Container fluid className="px-1" >
                <bie.Container className="outer-page-content-container shadow-none px-3 m-0 mw-100 pb-5">
                    <FormikProvider value={AfflInspUploadsFormik}>
                        <Form onChange={AfflInspUploadsFormik.handleChange} onSubmit={AfflInspUploadsFormik.handleSubmit} className='affl-form'>
                            <bie.Row className="px-2 pt-3 mb-3">

                                <bie.Alert variant='danger' className='affl-alert'>
                                    <p className='mb-0'>
                                        Note: Please avoid special characters like Single Quote ( ' ), Double Quotes ( " " ) Eg: NGO's, St.John's, etc.
                                    </p>

                                </bie.Alert>

                                <div className="table-responsive">
                                    <table className="table table-condensed table-bordered table-sm table-responsive affl-table">
                                        <thead>
                                            <tr>
                                                <th>SNO</th>
                                                <th>Document Description <b style={{ color: "#fff", fontSize: "18px" }}> *</b>	 </th>
                                                <th>Document Date  <b style={{ color: "#fff", fontSize: "18px" }}> *</b> </th>
                                                <th> Upload Document <b style={{ color: "#fff", fontSize: "18px" }}>* </b> </th>
                                                <th>Action</th>

                                            </tr>
                                        </thead>
                                        <tbody>
                                            <FieldArray name="AfflInspUploadArray">
                                                {(QualificationValues) => {
                                                    return QualificationValues.form.values.AfflInspUploadArray.map((qual, index) => {
                                                        return (
                                                            <>
                                                                <tr key={index}>
                                                                    <td>
                                                                        <center>{index + 1}</center>
                                                                    </td>
                                                                    <td>
                                                                        <Field type="text" className="form-control" name={`AfflInspUploadArray[${index}].docDescription`} maxLength="30" onKeyPress={(e) => { allowAlphabetAndSpacesOnly(e); }} />
                                                                        <ErrorMessage name={`AfflInspUploadArray[${index}].docDescription`} component="div" className="text-error" />
                                                                    </td>
                                                                    <td>  <Field type="date" className="form-control" name={`AfflInspUploadArray[${index}].docUploadingDate`} onKeyDown={(e) => { e.preventDefault() }} />
                                                                        <ErrorMessage name={`AfflInspUploadArray[${index}].docUploadingDate`} component="div" className="text-error" />
                                                                    </td>

                                                                    <td>
                                                                        <bie.Row className='align-items-center'>
                                                                            <bie.Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={6} className='mb-2'>
                                                                                <Field type="hidden" name={`AfflInspUploadArray[${index}].docUploading`} />
                                                                                <Field type="file" className="form-control" name={`AfflInspUploadArray[${index}].docUploadinghidden`} accept="application/pdf"
                                                                                    onChange={(e) => {
                                                                                        let fileVal = userId + "_" + acYear;
                                                                                        let filename = fileVal + "docUploading"
                                                                                        let path = "/Uploads/AffiliationPDFs/2024/INSPDocuments/"
                                                                                        ImagePdfBucket(e, AfflInspUploadsFormik, path, `AfflInspUploadArray[${index}].docUploading`, filename, "pdf")
                                                                                    }} />
                                                                            </bie.Col>
                                                                            <bie.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2} className='mb-2'>

                                                                                <ErrorMessage name={`AfflInspUploadArray[${index}].docUploadinghidden`} component="div" className="text-error" />
                                                                                {AfflInspUploadsFormik?.values?.AfflInspUploadArray[index]?.docUploading && <button type='button' className='btn btn-primary' onClick={() => { viewImage(AfflInspUploadsFormik?.values?.AfflInspUploadArray[index]?.docUploading) }}><FaEye size={20} /> </button>}



                                                                            </bie.Col>
                                                                        </bie.Row></td>
                                                                    <td colSpan={2} align="center" className="col-md-1">
                                                                        {(index >= 1 && AfflInspUploadsFormik?.values?.AfflInspUploadArray?.length >= 2) ? (
                                                                            <button
                                                                                type="button"
                                                                                className="button-titile btn btn-sm btn-danger"
                                                                                onClick={() => QualificationValues.remove(index)} >
                                                                                <FaRegTrashAlt />
                                                                            </button>
                                                                        ) : <td></td>}

                                                                    </td>

                                                                </tr>
                                                            </>
                                                        );
                                                    });
                                                }}
                                            </FieldArray>

                                            <tr className='table-active'>
                                                <td colSpan={7} className='pe-3 text-end'>
                                                    <FieldArray name="AfflInspUploadArray">
                                                        {(formikFieldArray) => {
                                                            return formikFieldArray.form.values.AfflInspUploadArray.map((LJP, i) => {
                                                                return (<>
                                                                    {(i === 0) ? <> <button type="button" className="button-titile btn btn-sm btn-success me-4"
                                                                        onClick={() => {
                                                                            formikFieldArray.push({
                                                                                docDescription: "",
                                                                                docUploadingDate: "",
                                                                                docUploading: ""

                                                                            });
                                                                        }}>
                                                                        <VscDiffAdded></VscDiffAdded>
                                                                    </button> </> : ''}
                                                                </>)
                                                            })
                                                        }}
                                                    </FieldArray>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div className="button-cend pt-1 mb-3">
                                    <button type="submit" className="btn btn-sm btn-success  mt-2 float-end mb-2">
                                        Submit
                                    </button>
                                </div>
                                {FfcaUploads.length > 0 ? (<>
                                    <div className="inner-herbpage-service-title-sub"><h1 className="mb-0"> Document Uploads Detailed Report</h1></div>
                                    <div className="table-responsive">
                                        <table className="table table-condensed table-bordered table-sm table-responsive affl-table">
                                            <thead>
                                                <tr>
                                                    <th>SNO</th>
                                                    <th>Document Description</th>
                                                    <th>Document Date  </th>
                                                    <th> Upload Document</th>
                                                    <th>Action</th>

                                                </tr>

                                            </thead>
                                            <tbody>
                                                {FfcaUploads && FfcaUploads?.map((uploadsData, index) => (<>
                                                    <tr key={index}>
                                                        <td className='cen'>{index + 1}</td>
                                                        <td className='text-left'>{uploadsData?.doc_descrption}</td>
                                                        <td className='cen'>{uploadsData?.doc_uploading_date}</td>

                                                        <td className='cen'>
                                                            <button type='button'
                                                                className="btn btn-primary"
                                                                onClick={() => { viewImage(uploadsData?.doc_uploading); }}
                                                            >
                                                                <FaEye
                                                                    size={20}
                                                                />
                                                            </button>
                                                        </td>

                                                        <td className='cen'>
                                                            <bie.Button
                                                                type="button" className="btn btn-danger"
                                                                onClick={() => { DeleteUploadFile(uploadsData.sno); }}><BiTrash />
                                                            </bie.Button>
                                                        </td>

                                                    </tr>
                                                </>))}
                                            </tbody >
                                        </table>
                                    </div>
                                </>) : null}

                            </bie.Row>
                        </Form>
                    </FormikProvider>
                </bie.Container>
            </bie.Container>

        </>
    )
}

